module.exports = __webpack_public_path__ + "img/parker-westport-card.4df8299e.webp";